export default "__VITE_ASSET__f39eea1b__"